/* ============================================================
   mobileCasez — reskin interaction engine
   Vanilla JS. No dependencies. Wires the ported design to the
   real Shopify cart (AJAX + Section Rendering API).
   ============================================================ */
(function () {
  'use strict';

  var CART_SECTION = 'tf-cart-drawer';

  /* -------- tiny helpers -------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }

  /* -------- money (Shopify format) -------- */
  function formatMoney(cents) {
    var fmt = window.tfMoneyFormat || '&#8377;{{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.tfFormatMoney = formatMoney;

  /* ===========================================================
     1) HOVER ENGINE — honours the design's `style-hover` attribute
     =========================================================== */
  function parseStyle(str) {
    var out = {};
    (str || '').split(';').forEach(function (d) {
      var i = d.indexOf(':');
      if (i > -1) {
        var prop = d.slice(0, i).trim();
        var val = d.slice(i + 1).trim();
        if (prop) out[prop] = val;
      }
    });
    return out;
  }
  function initHover(root) {
    $all('[style-hover]', root).forEach(function (el) {
      if (el.__tfHover) return;
      el.__tfHover = true;
      var hover = parseStyle(el.getAttribute('style-hover'));
      var props = Object.keys(hover);
      if (!props.length) return;
      var enter = function () {
        el.__tfPrev = {};
        props.forEach(function (p) {
          el.__tfPrev[p] = el.style.getPropertyValue(p);
          el.style.setProperty(p, hover[p]);
        });
      };
      var leave = function () {
        if (!el.__tfPrev) return;
        props.forEach(function (p) {
          if (el.__tfPrev[p]) el.style.setProperty(p, el.__tfPrev[p]);
          else el.style.removeProperty(p);
        });
      };
      on(el, 'mouseenter', enter);
      on(el, 'mouseleave', leave);
      on(el, 'focus', enter);
      on(el, 'blur', leave);
    });
  }

  /* ===========================================================
     2) CART — real Shopify AJAX + Section Rendering API
     =========================================================== */
  function updateCounts(count) {
    $all('[data-tf-cart-count]').forEach(function (n) { n.textContent = count; });
  }
  function refreshDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-tf-cart-root]');
    var current = $('[data-tf-cart-root]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      var c = fresh.getAttribute('data-cart-count');
      if (c != null) updateCounts(c);
      initHover(current);
    }
  }
  function cartRequest(url, body) {
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function openCart() { toggleOverlay('tf-cart', true); }
  function closeCart() { toggleOverlay('tf-cart', false); }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    if (!variantId) return;
    return cartRequest('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function (data) {
        if (data && data.status) { // error object
          tfToast(data.description || 'Could not add to cart');
          return;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCounts(cart.item_count);
          return renderDrawerFromApi().then(function () {
            if (opts.silent !== true) { openCart(); }
            tfToast('✦ Added — ' + (opts.name || (data.items && data.items[0] && data.items[0].product_title) || 'item'));
          });
        });
      })
      .catch(function () { tfToast('Network error — try again'); });
  }
  function changeLine(key, qty) {
    return cartRequest('/cart/change.js', { id: key, quantity: qty })
      .then(function (data) {
        updateCounts(data.item_count);
        return renderDrawerFromApi();
      });
  }
  // Re-render the drawer section via the Section Rendering API
  function renderDrawerFromApi() {
    return fetch('/?sections=' + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (json) { refreshDrawer(json[CART_SECTION]); })
      .catch(function () {});
  }

  function initCart(root) {
    // openers / closers
    $all('[data-tf-open-cart]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openCart(); }); });
    $all('[data-tf-close-cart]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); closeCart(); }); });

    // event-delegated quick-add + line controls (survive drawer re-render)
    if (!document.__tfCartDelegated) {
      document.__tfCartDelegated = true;
      document.addEventListener('click', function (e) {
        var add = e.target.closest && e.target.closest('[data-tf-add]');
        if (add) {
          e.preventDefault();
          addToCart(add.getAttribute('data-variant'), parseInt(add.getAttribute('data-qty') || '1', 10), { name: add.getAttribute('data-name') });
          return;
        }
        var inc = e.target.closest && e.target.closest('[data-tf-line-inc]');
        var dec = e.target.closest && e.target.closest('[data-tf-line-dec]');
        var rm = e.target.closest && e.target.closest('[data-tf-line-remove]');
        var node = inc || dec || rm;
        if (node) {
          e.preventDefault();
          var line = node.getAttribute('data-key');
          var cur = parseInt(node.getAttribute('data-qty') || '1', 10);
          if (inc) changeLine(line, cur + 1);
          else if (dec) changeLine(line, Math.max(0, cur - 1));
          else changeLine(line, 0);
        }
      });
    }
  }

  /* ===========================================================
     3) OVERLAYS (cart / menu / deal / toast)
     =========================================================== */
  function toggleOverlay(id, open) {
    var el = document.getElementById(id);
    if (!el) return;
    if (open) { el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    else {
      el.classList.remove('is-open');
      // only unlock if no other overlay open
      if (!$('.tf-overlay.is-open')) document.documentElement.style.overflow = '';
    }
    // Hide floating UI (mobile add-to-cart bar, back-to-top) while any drawer or
    // overlay is open, so it can't cover the drawer's controls — e.g. Checkout.
    document.body.classList.toggle('tf-overlay-open', !!$('.tf-overlay.is-open'));
  }
  window.tfToggleOverlay = toggleOverlay;

  function initMenu(root) {
    $all('[data-tf-open-menu]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('tf-menu', true); }); });
    $all('[data-tf-close-menu]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('tf-menu', false); }); });
    $all('#tf-menu a').forEach(function (a) { on(a, 'click', function () { toggleOverlay('tf-menu', false); }); });
  }

  var toastTimer;
  function tfToast(msg) {
    var host = $('[data-tf-toast]');
    if (!host) return;
    host.textContent = msg;
    host.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.classList.remove('is-open'); }, 2200);
  }
  window.tfToast = tfToast;

  function initDeal(root) {
    var deal = document.getElementById('tf-deal');
    if (!deal || deal.__tf) return; deal.__tf = true;
    var cfg = {
      freq: deal.getAttribute('data-freq') || 'session',           // page | session | day
      delay: (parseFloat(deal.getAttribute('data-delay')) || 3) * 1000,
      tmode: deal.getAttribute('data-timer-mode') || 'evergreen',  // evergreen | fixed
      mins: parseInt(deal.getAttribute('data-minutes') || '15', 10),
      end: deal.getAttribute('data-end') || '',
      hideExpired: deal.getAttribute('data-hide-expired') !== 'false',
      design: deal.getAttribute('data-design-mode') === 'true'
    };

    // ---- countdown deadline ----
    // fixed mode: only a real, merchant-set end date produces a timer.
    // evergreen mode: one deadline per session; an expired deadline is NEVER
    // re-minted (no perpetually-restarting fake urgency).
    var deadline = null;
    if (cfg.tmode === 'fixed') {
      if (cfg.end) {
        var d = new Date(cfg.end.replace(' ', 'T'));
        if (!isNaN(d.getTime())) deadline = d.getTime();
      }
      // blank/invalid end date -> no timer at all
    } else { // evergreen
      var stored = null;
      try { var s = sessionStorage.getItem('tf-deal-deadline'); if (s) stored = parseInt(s, 10); } catch (e) {}
      if (stored) {
        deadline = stored; // keep it, even if already expired
      } else {
        deadline = Date.now() + cfg.mins * 60000;
        try { sessionStorage.setItem('tf-deal-deadline', '' + deadline); } catch (e) {}
      }
    }
    var hasTimer = deadline !== null;
    var twrap = $('[data-tf-t-wrap]', deal);
    if (!hasTimer && twrap) twrap.style.display = 'none';
    function expired() { return hasTimer && deadline - Date.now() <= 0; }

    // ---- frequency gate ----
    function seen() {
      try {
        if (cfg.freq === 'session') return !!sessionStorage.getItem('tf-deal-dismissed');
        if (cfg.freq === 'day') return localStorage.getItem('tf-deal-day') === new Date().toDateString();
      } catch (e) {}
      return false; // 'page' → show on every page view
    }
    function markSeen() {
      try {
        sessionStorage.setItem('tf-deal-dismissed', '1');
        localStorage.setItem('tf-deal-day', new Date().toDateString());
      } catch (e) {}
    }

    // ---- timer rendering ----
    var tick;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function renderTimer() {
      var ms = Math.max(0, deadline - Date.now());
      var dd = Math.floor(ms / 86400000);
      var hh = Math.floor(ms / 3600000) % 24;
      var mm = Math.floor(ms / 60000) % 60;
      var ss = Math.floor(ms / 1000) % 60;
      var eD = $('[data-tf-t-d]', deal), eH = $('[data-tf-t-h]', deal), eM = $('[data-tf-t-m]', deal), eS = $('[data-tf-t-s]', deal);
      if (eD) { eD.textContent = pad(dd); var b = eD.closest('[data-tf-t-box]'); if (b) b.style.display = dd > 0 ? '' : 'none'; }
      if (eH) eH.textContent = pad(hh);
      if (eM) eM.textContent = pad(mm);
      if (eS) eS.textContent = pad(ss);
      if (ms <= 0) {
        clearInterval(tick);
        if (cfg.hideExpired && !cfg.design) toggleOverlay('tf-deal', false);
      }
    }
    function openDeal() {
      if (expired() && cfg.hideExpired && !cfg.design) return;
      toggleOverlay('tf-deal', true);
      if (!cfg.design) markSeen();
      if (hasTimer) {
        renderTimer();
        clearInterval(tick);
        tick = setInterval(renderTimer, 1000);
      }
    }

    // ---- closers ----
    $all('[data-tf-close-deal]', deal).forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('tf-deal', false); clearInterval(tick); });
    });

    // ---- click-to-copy coupon ----
    var coupon = $('[data-tf-coupon]', deal);
    on(coupon, 'click', function () {
      var code = coupon.getAttribute('data-code') || '';
      var state = $('[data-tf-copy-state]', deal);
      function done() {
        tfApplyDiscount(code);
        if (state) {
          var prev = state.getAttribute('data-idle') || state.textContent;
          state.setAttribute('data-idle', prev);
          state.textContent = 'Copied & applied ✓';
          setTimeout(function () { state.textContent = prev; }, 2400);
        }
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        ta.remove();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallback(); done(); });
      } else { fallback(); done(); }
    });

    // ---- schedule ----
    // Never auto-open on a paid-ad landing view (gclid & co.) — keeps the ads
    // landing-page experience clean and avoids interstitial policy trouble.
    var adLanding = /[?&](gclid|gbraid|wbraid|msclkid|fbclid|ttclid)=/i.test(window.location.search);
    if (adLanding) { try { sessionStorage.setItem('tf-deal-dismissed', '1'); } catch (e) {} } // keep the whole ad session clean
    if (cfg.design) {
      setTimeout(openDeal, 400);
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains && e.target.contains(deal)) openDeal();
      });
    } else if (!adLanding && !seen() && !(expired() && cfg.hideExpired)) {
      deal.__tfTimer = setTimeout(openDeal, cfg.delay);
    }
  }

  // click on a scrim closes its overlay
  function initScrims() {
    if (document.__tfScrims) return; document.__tfScrims = true;
    $all('[data-tf-scrim]').forEach(function (s) {
      on(s, 'click', function () {
        var ov = s.closest('.tf-overlay');
        if (ov) toggleOverlay(ov.id, false);
      });
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') { var o = $('.tf-overlay.is-open'); if (o) toggleOverlay(o.id, false); }
    });
  }

  /* ===========================================================
     4) CAMPAIGN CAROUSEL
     =========================================================== */
  function initCarousels(root) {
    $all('[data-tf-carousel]', root).forEach(function (car) {
      if (car.__tf) return; car.__tf = true;
      var track = $('[data-tf-track]', car);
      var slides = track ? $all(':scope > *', track) : [];
      // controls (arrows/dots) live in the section header/footer, OUTSIDE the
      // carousel box — scope lookups to the enclosing section
      var scope = car.closest('section') || car.closest('.shopify-section') || car;
      var dots = $all('[data-tf-dot]', scope);
      var n = slides.length;
      if (!track || n < 2) return;
      var idx = 0, paused = false;
      var auto = car.getAttribute('data-autorotate') !== 'false';
      function go(i) {
        idx = (i + n) % n;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, di) {
          d.style.background = di === idx ? 'var(--accent,#D8FF3E)' : 'rgba(20,21,26,.14)';
        });
      }
      $all('[data-tf-prev]', scope).forEach(function (b) { on(b, 'click', function () { go(idx - 1); }); });
      $all('[data-tf-next]', scope).forEach(function (b) { on(b, 'click', function () { go(idx + 1); }); });
      dots.forEach(function (d, di) { on(d, 'click', function () { go(di); }); });
      on(car, 'mouseenter', function () { paused = true; });
      on(car, 'mouseleave', function () { paused = false; });
      // touch swipe for mobile
      var swipeX = null;
      on(track, 'touchstart', function (e) { swipeX = e.touches[0].clientX; paused = true; }, { passive: true });
      on(track, 'touchend', function (e) {
        if (swipeX === null) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        swipeX = null; paused = false;
        if (Math.abs(dx) > 40) { if (dx < 0) go(idx + 1); else go(idx - 1); }
      }, { passive: true });
      go(0);
      if (auto) {
        setInterval(function () {
          if (!paused && !document.hidden && !(window.Shopify && window.Shopify.designMode)) go(idx + 1);
        }, 5000);
      }
    });
  }

  // On mobile, the campaign slider section moves ABOVE the hero (design spec);
  // desktop keeps the authored order. Sections are siblings inside MainContent.
  function initMobileOrder() {
    var car = $('[data-tf-carousel]');
    var hero = $('[data-tf-hero]');
    if (!car || !hero) return;
    var carSec = car.closest('.shopify-section');
    var heroSec = hero.closest('.shopify-section');
    if (!carSec || !heroSec || carSec === heroSec || carSec.parentElement !== heroSec.parentElement) return;
    if (heroSec.__tfOrder) return; heroSec.__tfOrder = true;
    var mq = window.matchMedia('(max-width: 860px)');
    function apply() {
      if (mq.matches) heroSec.parentElement.insertBefore(carSec, heroSec);
      else heroSec.parentElement.insertBefore(heroSec, carSec);
    }
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
    apply();
  }

  /* ===========================================================
     5) SCROLL REVEAL + HERO TILT
     =========================================================== */
  function initReveal(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = $all('[data-reveal]', root);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.style.opacity = '1'; }); return; }
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) {
      if (el.__tfR) return; el.__tfR = true;
      if (el.getBoundingClientRect().top > vh * 0.92) {
        el.style.opacity = '0'; el.style.transform = 'translateY(26px)';
        el.style.transition = 'opacity .7s ease, transform .7s ease';
        io.observe(el);
      }
    });
  }
  function initTilt(root) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    $all('[data-tilt]', root).forEach(function (el) {
      if (el.__tfT) return; el.__tfT = true;
      on(el, 'mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg)';
      });
      on(el, 'mouseleave', function () { el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)'; });
    });
  }

  /* ===========================================================
     6) PRODUCT PAGE
     =========================================================== */
  function initPDP(root) {
    $all('[data-tf-pdp]', root).forEach(function (pdp) {
      if (pdp.__tf) return; pdp.__tf = true;

      // sticky add-to-cart bar (mobile) — mirrors the main button
      var sticky = document.querySelector('[data-tf-sticky]');
      var mainAtc = $('[data-tf-atc]', pdp);
      if (sticky && mainAtc) {
        var stickyBtn = sticky.querySelector('[data-tf-sticky-add]');
        var stickyPrice = sticky.querySelector('[data-tf-sticky-price]');
        var unitPrice = $('[data-tf-price]', pdp);
        // sticky quantity mirrors the main quantity stepper (both directions)
        var mainQtyInc = $('[data-tf-qty-inc]', pdp);
        var mainQtyDec = $('[data-tf-qty-dec]', pdp);
        var mainQtyVal = $('[data-tf-qty-val]', pdp);
        var stickyQty = sticky.querySelector('[data-tf-sticky-qty]');
        var stickyInc = sticky.querySelector('[data-tf-sticky-inc]');
        var stickyDec = sticky.querySelector('[data-tf-sticky-dec]');
        function syncQty() { if (stickyQty && mainQtyVal) stickyQty.textContent = mainQtyVal.textContent; }
        if (stickyInc && mainQtyInc) on(stickyInc, 'click', function () { mainQtyInc.click(); syncQty(); });
        if (stickyDec && mainQtyDec) on(stickyDec, 'click', function () { mainQtyDec.click(); syncQty(); });
        if (stickyBtn) on(stickyBtn, 'click', function () { mainAtc.click(); });
        function syncPrice() { if (stickyPrice && unitPrice) stickyPrice.textContent = unitPrice.textContent; }
        syncQty();
        var show = false;
        function toggle() {
          var r = mainAtc.getBoundingClientRect();
          var past = r.bottom < 0 || r.top > (window.innerHeight || 0);
          if (past !== show) { show = past; sticky.hidden = !past; sticky.style.display = past ? 'flex' : 'none'; syncPrice(); syncQty(); }
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (e) {
            var vis = e[0].isIntersecting;
            sticky.hidden = vis; sticky.style.display = vis ? 'none' : 'flex'; if (!vis) { syncPrice(); syncQty(); }
          }, { rootMargin: '0px' }).observe(mainAtc);
        } else {
          on(window, 'scroll', toggle, { passive: true }); toggle();
        }
        pdp.addEventListener('change', function () { syncPrice(); syncQty(); });
        pdp.addEventListener('click', function () { setTimeout(function () { syncPrice(); syncQty(); }, 30); });
      }

      // gallery
      var mainImg = $('[data-tf-main-img]', pdp);
      $all('[data-tf-thumb]', pdp).forEach(function (t) {
        on(t, 'click', function () {
          var src = t.getAttribute('data-src');
          if (mainImg && src) mainImg.src = src;
          $all('[data-tf-thumb]', pdp).forEach(function (o) { o.style.borderColor = 'transparent'; });
          t.style.borderColor = 'var(--accent,#D8FF3E)';
        });
      });

      // variants
      var variants = [];
      try { variants = JSON.parse(($('[data-tf-variants]', pdp) || {}).textContent || '[]'); } catch (e) {}
      var current = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
      var selected = {};
      var atc = $('[data-tf-atc]', pdp);

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] == null || selected[i] === o; });
        });
      }
      function priceCents() { return current ? current.price : 0; }
      function refresh() {
        var qty = getQty();
        var priceEl = $('[data-tf-price]', pdp);
        var mrpEl = $('[data-tf-mrp]', pdp);
        var totalEl = $('[data-tf-atc-total]', pdp);
        // keep the real form inputs in step, so a no-JS / failed-AJAX submit
        // still posts the chosen variant and quantity
        var vInput = $('[data-tf-variant-input]', pdp);
        var qInput = $('[data-tf-qty-input]', pdp);
        if (vInput && current) vInput.value = current.id;
        if (qInput) qInput.value = qty;
        if (current && priceEl) priceEl.innerHTML = formatMoney(current.price);
        if (current && mrpEl) { if (current.compare > current.price) { mrpEl.innerHTML = formatMoney(current.compare); mrpEl.style.display = ''; } else { mrpEl.style.display = 'none'; } }
        // "Add to cart — ₹3,499": the line total, in step with variant + quantity
        if (totalEl) {
          if (current && current.available) {
            totalEl.innerHTML = ' — ' + formatMoney(current.price * qty);
            totalEl.style.display = '';
          } else {
            totalEl.style.display = 'none';
          }
        }
        if (atc) {
          if (current && current.available) {
            atc.removeAttribute('disabled');
            atc.style.opacity = '';
            atc.setAttribute('data-variant', current.id);
            atc.setAttribute('data-qty', qty);
            var lbl = $('[data-tf-atc-label]', atc);
            if (lbl) lbl.textContent = atc.getAttribute('data-label') || 'Add to cart';
          } else {
            atc.setAttribute('disabled', 'disabled');
            atc.style.opacity = '.5';
            var lbl2 = $('[data-tf-atc-label]', atc);
            if (lbl2) lbl2.textContent = current ? 'Sold out' : 'Unavailable';
          }
        }
      }
      // option pickers
      $all('[data-tf-option]', pdp).forEach(function (picker) {
        var oi = parseInt(picker.getAttribute('data-tf-option'), 10);
        $all('[data-tf-value]', picker).forEach(function (btn) {
          on(btn, 'click', function () {
            selected[oi] = btn.getAttribute('data-tf-value');
            $all('[data-tf-value]', picker).forEach(function (o) { o.setAttribute('data-active', 'false'); });
            btn.setAttribute('data-active', 'true');
            current = findVariant() || null;
            refresh();
          });
        });
      });

      // qty
      var qtyVal = $('[data-tf-qty-val]', pdp);
      function getQty() { return qtyVal ? parseInt(qtyVal.textContent || '1', 10) : 1; }
      function setQty(q) { q = Math.max(1, q); if (qtyVal) qtyVal.textContent = q; refresh(); }
      on($('[data-tf-qty-inc]', pdp), 'click', function () { setQty(getQty() + 1); });
      on($('[data-tf-qty-dec]', pdp), 'click', function () { setQty(getQty() - 1); });

      // add to cart
      on(atc, 'click', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        addToCart(current.id, getQty(), { name: pdp.getAttribute('data-name') });
      });

      refresh();
    });
  }

  /* ===========================================================
     7) COLLECTION filter + sort (client-side over rendered cards)
     =========================================================== */
  function initCollection(root) {
    $all('[data-tf-collection]', root).forEach(function (col) {
      if (col.hasAttribute('data-tf-facets')) return; // tf-filters.js owns it
      if (col.__tf) return; col.__tf = true;
      var grid = $('[data-tf-grid]', col);
      if (!grid) return;
      var cards = $all('[data-tf-card]', grid);
      var promo = $('[data-tf-promo]', grid);
      var noRes = $('[data-tf-empty]', col);
      var shownLabel = $('[data-tf-shown]', col);
      var brand = 'all';
      var sort = 'featured';

      function apply() {
        var visible = 0;
        cards.forEach(function (c) {
          var b = (c.getAttribute('data-brand') || '').toLowerCase();
          var match = brand === 'all' || b === brand;
          c.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        // sort visible
        var arr = cards.filter(function (c) { return c.style.display !== 'none'; });
        arr.sort(function (a, b) {
          if (sort === 'price-asc') return num(a, 'price') - num(b, 'price');
          if (sort === 'price-desc') return num(b, 'price') - num(a, 'price');
          if (sort === 'rating') return num(b, 'rating') - num(a, 'rating');
          return num(a, 'order') - num(b, 'order');
        });
        arr.forEach(function (c) { grid.insertBefore(c, promo || null); });
        if (promo) grid.appendChild(promo);
        if (noRes) noRes.style.display = visible ? 'none' : '';
        if (grid) grid.style.display = visible ? 'grid' : 'none';
        if (shownLabel) {
          // Design format: "SHOWING 05 / 24 — EVERYTHING"
          var total = parseInt(shownLabel.getAttribute('data-total') || '', 10);
          if (!total && total !== 0) total = cards.length;
          var scope = brand === 'all'
            ? (shownLabel.getAttribute('data-all-label') || 'EVERYTHING')
            : brand.toUpperCase();
          shownLabel.textContent = 'SHOWING ' + pad2(visible) + ' / ' + pad2(total) + ' — ' + scope;
        }
        var clear = $('[data-tf-clear]', col);
        if (clear) clear.style.display = brand === 'all' ? 'none' : '';
      }
      function num(c, key) { return parseFloat(c.getAttribute('data-' + key) || '0'); }
      function pad2(n) { return n < 10 ? '0' + n : String(n); }

      $all('[data-tf-filter]', col).forEach(function (chip) {
        on(chip, 'click', function () {
          brand = (chip.getAttribute('data-tf-filter') || 'all').toLowerCase();
          $all('[data-tf-filter]', col).forEach(function (o) { o.setAttribute('data-active', 'false'); });
          chip.setAttribute('data-active', 'true');
          apply();
        });
      });
      $all('[data-tf-clear]', col).forEach(function (b) {
        on(b, 'click', function () {
          brand = 'all';
          $all('[data-tf-filter]', col).forEach(function (o) { o.setAttribute('data-active', o.getAttribute('data-tf-filter') === 'all' ? 'true' : 'false'); });
          apply();
        });
      });
      var sel = $('[data-tf-sort]', col);
      on(sel, 'change', function () { sort = sel.value; apply(); });

      // read brand from URL (?b=apple)
      try {
        var p = new URLSearchParams(window.location.search).get('b');
        if (p) { brand = p.toLowerCase(); var target = $('[data-tf-filter="' + brand + '"]', col); if (target) target.click(); }
      } catch (e) {}
      apply();
    });
  }

  /* ===========================================================
     8) RELATED products — native recommendations fetch, graceful fallback
     =========================================================== */
  function initRelated(root) {
    $all('[data-tf-related]', root).forEach(function (sec) {
      if (sec.__tf) return; sec.__tf = true;
      var target = $('[data-tf-rel-target]', sec);
      if (!target) return; // merchant-linked rail already rendered server-side
      var fallback = $('[data-tf-rel-fallback]', sec);
      function useFallback() {
        if (target.parentNode) target.remove();
        if (fallback) fallback.hidden = false;
        else sec.style.display = 'none';
      }
      fetch(target.getAttribute('data-url'))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rail = doc.querySelector('[data-tf-rel-products]');
          if (rail && rail.querySelector('[data-tf-card]')) {
            target.replaceWith(rail);
            if (fallback) fallback.remove();
            init(rail); // bind hover/carousel on the injected cards
          } else useFallback();
        })
        .catch(useFallback);
    });
  }

  /* ===========================================================
     9) SCROLL-TO-TOP button
     =========================================================== */
  function initScrollTop() {
    var btn = document.querySelector('[data-tf-scrolltop]');
    if (!btn || btn.__tf) return; btn.__tf = true;
    on(btn, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    function upd() {
      var show = (window.pageYOffset || document.documentElement.scrollTop) > 400;
      btn.style.opacity = show ? '1' : '0';
      btn.style.pointerEvents = show ? 'auto' : 'none';
      btn.style.transform = show ? 'translateY(0)' : 'translateY(8px)';
    }
    on(window, 'scroll', upd, { passive: true }); upd();
  }

  /* ===========================================================
     INIT
     =========================================================== */
  /* ===========================================================
     PREDICTIVE SEARCH (header) — instant product results
     =========================================================== */
  function initSearch(root) {
    var openBtn = $('[data-tf-open-search]', root);
    var panel = document.getElementById('tf-search');
    if (!panel) return;
    var input = panel.querySelector('[data-tf-search-input]');
    var results = panel.querySelector('[data-tf-search-results]');
    var statusEl = panel.querySelector('[data-tf-search-status]');
    var allLink = panel.querySelector('[data-tf-search-all]');
    function close() { toggleOverlay('tf-search', false); }
    if (openBtn && !openBtn.__tf) {
      openBtn.__tf = 1;
      on(openBtn, 'click', function () { toggleOverlay('tf-search', true); setTimeout(function () { if (input) input.focus(); }, 60); });
    }
    $all('[data-tf-close-search], [data-tf-close-search-scrim]', panel).forEach(function (b) { if (b.__tf) return; b.__tf = 1; on(b, 'click', close); });
    if (!panel.__tfEsc) { panel.__tfEsc = 1; on(document, 'keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); }); }
    function render(products, q) {
      if (!products || !products.length) { results.innerHTML = ''; statusEl.textContent = q ? 'No matches for “' + q + '”' : ''; if (allLink) allLink.style.display = 'none'; return; }
      results.innerHTML = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var pn = (p.price != null && p.price !== '') ? parseFloat(p.price) : NaN;
        var price = isNaN(pn) ? '' : formatMoney(Math.round(pn * 100));
        return '<a href="' + p.url + '" class="tf-search-row" style="display:flex;align-items:center;gap:14px;padding:10px;border-radius:14px;text-decoration:none;color:#15161A">'
          + (img ? '<img src="' + img + '" width="52" height="52" loading="lazy" alt="" style="width:52px;height:52px;border-radius:10px;object-fit:contain;background:#fff;border:1px solid rgba(20,21,26,.08);flex-shrink:0">' : '')
          + '<span style="flex:1;min-width:0"><span style="display:block;font-weight:600;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + p.title + '</span>'
          + (price ? '<span style="display:block;font-size:13px;color:#5C615B;margin-top:2px">' + price + '</span>' : '') + '</span></a>';
      }).join('');
      statusEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '');
      if (allLink) { allLink.href = (allLink.getAttribute('data-base') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product'; allLink.style.display = 'inline-flex'; }
    }
    var t;
    function run(q) {
      if (!q || q.length < 2) { results.innerHTML = ''; statusEl.textContent = ''; if (allLink) allLink.style.display = 'none'; return; }
      statusEl.textContent = 'Searching…';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { var pr = (d && d.resources && d.resources.results && d.resources.results.products) || []; render(pr, q); })
        .catch(function () { statusEl.textContent = ''; });
    }
    if (input && !input.__tf) {
      input.__tf = 1;
      on(input, 'input', function () { clearTimeout(t); var q = input.value.trim(); t = setTimeout(function () { run(q); }, 250); });
    }
  }

  function init(root) {
    root = root || document;
    initHover(root);
    initCart(root);
    initMenu(root);
    initSearch(root);
    initScrollTop();
    initDeal(root);
    initScrims();
    initCarousels(root);
    initMobileOrder();
    initReveal(root);
    initTilt(root);
    initPDP(root);
    initCollection(root);
    initRelated(root);
  }
  window.__tfInit = init;

  // linked-options model dropdown → navigate to the sibling product
  document.addEventListener('change', function (e) {
    var nav = e.target.closest && e.target.closest('[data-tf-lo-nav]');
    if (nav && nav.value) window.location.href = nav.value;
  });

  // ---- store-wide coupon: copying the code auto-applies it so it carries to checkout ----
  function tfApplyDiscount(code) {
    if (!code) return;
    try { localStorage.setItem('tf-discount', code); } catch (e) {}
    // Canonical Shopify auto-apply: hitting /discount/<code> sets the discount
    // cookie for this session, so it's already applied at checkout — no manual paste.
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
  }
  window.__tfApplyDiscount = tfApplyDiscount;
  // Fail-safe: send checkout LINKS through the discount URL too (covers the case
  // where the background cookie didn't stick). Form submit buttons rely on the cookie.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[href^="/checkout"]');
    if (!el) return;
    var code = null; try { code = localStorage.getItem('tf-discount'); } catch (er) {}
    if (!code) return;
    var dest = el.getAttribute('href') || '/checkout';
    e.preventDefault();
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function () {});
})();
